import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { TabView, TabPanel } from 'primereact/tabview';
import { Tag } from 'primereact/tag';
import { Toast } from 'primereact/toast';
import CadastroDataTable from '../components/CadastroDataTable/CadastroDataTable';
import api, { normalize } from '../services/api';
import './PerfilPage.css';
import './nfse/NfseConsulta.css';

/** Remove FAQs duplicadas pelo mesmo código, mantendo a primeira ocorrência. */
function dedupeByCodigo(list) {
  return [...new Map((list || []).map((f) => [f.codigo, f])).values()];
}

export default function HelpPage() {
  const toast = useRef(null);
  const [searchParams] = useSearchParams();
  const isPreview = searchParams.get('preview') === '1';
  const [videos, setVideos] = useState([]);
  const [faq, setFaq] = useState([]);
  const [erros, setErros] = useState([]);
  const [roteiros, setRoteiros] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const [v, f, e, r] = await Promise.all([
          api.get('/help/videos'),
          api.get('/help/faq'),
          api.get('/help/erros'),
          api.get('/help/roteiros'),
        ]);
        setVideos(normalize(v.data));
        setFaq(dedupeByCodigo(normalize(f.data)));
        setErros(normalize(e.data));
        setRoteiros(normalize(r.data));
      } catch (err) {
        toast.current?.show({
          severity: 'error',
          summary: 'Erro',
          detail: err.response?.data?.message || 'Falha ao carregar ajuda.',
        });
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const videoCols = [
    { field: 'codigo', header: 'Código', style: { width: 100 } },
    { field: 'titulo', header: 'Título' },
    { field: 'descricao', header: 'Descrição' },
    {
      field: 'url',
      header: 'Link',
      body: (row) =>
        row.url ? (
          <a href={row.url} target="_blank" rel="noreferrer">
            Abrir
          </a>
        ) : (
          '—'
        ),
    },
  ];

  const faqCols = [
    { field: 'codigo', header: 'Código', style: { width: 90 } },
    { field: 'contexto', header: 'Contexto', style: { width: 120 } },
    { field: 'pergunta', header: 'Pergunta' },
    { field: 'resposta', header: 'Resposta' },
  ];

  const erroCols = [
    { field: 'codigo', header: 'Código', style: { width: 100 } },
    { field: 'severidade', header: 'Severidade', style: { width: 110 } },
    { field: 'mensagemAmigavel', header: 'Mensagem' },
    { field: 'comoResolver', header: 'Como resolver' },
  ];

  const roteiroCols = [
    { field: 'codigo', header: 'Código', style: { width: 90 } },
    { field: 'titulo', header: 'Roteiro' },
  ];

  return (
    <div className="config-page">
      <Toast ref={toast} />
      <div className="nfse-consulta-header">
        <h1>
          Ajuda e treinamentos{' '}
          {isPreview && <Tag severity="warning" value="Preview / em desenvolvimento" />}
        </h1>
      </div>
      {isPreview && (
        <p style={{ color: '#64748b', marginTop: -8 }}>
          Esta página está em preview e ainda não faz parte do menu principal — conteúdo e layout
          podem mudar.
        </p>
      )}

      <TabView className="config-tabs">
        <TabPanel header="Vídeos">
          <CadastroDataTable
            value={videos}
            columns={videoCols}
            storageKey="help-videos"
            loading={loading}
            title="Vídeos"
            emptyMessage="Nenhum vídeo cadastrado."
            globalFilterFields={['codigo', 'titulo', 'descricao']}
          />
        </TabPanel>
        <TabPanel header="FAQ">
          <CadastroDataTable
            value={faq}
            columns={faqCols}
            storageKey="help-faq"
            loading={loading}
            title="FAQ"
            emptyMessage="Nenhuma pergunta frequente."
            globalFilterFields={['codigo', 'contexto', 'pergunta', 'resposta']}
          />
        </TabPanel>
        <TabPanel header="Erros">
          <CadastroDataTable
            value={erros}
            columns={erroCols}
            storageKey="help-erros"
            loading={loading}
            title="Catálogo de erros"
            emptyMessage="Nenhum erro catalogado."
            globalFilterFields={['codigo', 'mensagemAmigavel', 'comoResolver']}
          />
        </TabPanel>
        <TabPanel header="Roteiros">
          <CadastroDataTable
            value={roteiros}
            columns={roteiroCols}
            storageKey="help-roteiros"
            loading={loading}
            title="Roteiros"
            emptyMessage="Nenhum roteiro."
            globalFilterFields={['codigo', 'titulo']}
          />
        </TabPanel>
      </TabView>
    </div>
  );
}
